import { DataModelV2 } from "./data"
import { Event } from "./Event"
import { AutoStoppingCarousel } from "./support/AutoStoppingCarousel";
import { useInstance } from "@meraki-internal/react-dependency-injection";

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};
export const Events: React.FC = () => {
    const model = useInstance(DataModelV2);

    const events = model.getAllEvents();

    // TODO: past events!

    return (
        <section className="section-content-block" id="events" style={{scrollMarginTop: '5.2rem' }}>
            <div className="container">
                <div className="row section-heading-wrapper">
                    <div className="col-md-12 col-sm-12 text-center">
                        <h2>This Season's <span>Events</span></h2>
                    </div>
                </div>
                <AutoStoppingCarousel responsive={responsive}
                    autoPlaySpeed={4000}
                    infinite
                >
                    {events.map((event, i)  => (
                        <Event key={event.url} event={{
                            ...event,
                            imagePath: i % 2 === 0 ? 'images/push-back/push-back-1.png' : 'images/push-back/push-back-2.jpg'
                        }}  />
                    ))}
                </AutoStoppingCarousel>
            </div>

        </section>

    )
}